import * as React from "react";

import styles from "./ResourceView.module.css";

interface ResourceViewRootProps {
  children: React.ReactNode;
}

/**
 * Outermost shell of the `ResourceView` compound: a full-height flex column
 * that hosts a `<DataTable>` and any sibling chrome (filters, banners).
 *
 * @example
 * ```tsx
 * <ResourceView.Root>
 *   <DataTable {...tableProps} />
 * </ResourceView.Root>
 * ```
 */
export function ResourceViewRoot({ children }: ResourceViewRootProps) {
  return <div className={styles.container}>{children}</div>;
}
